module.exports = __webpack_public_path__ + "static/media/external-link.18ea418e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link.svg
// module id = 533
// module chunks = 0